export default "__VITE_ASSET__9b53c3eb__"